export const extractInitials = (input: string, maxWords = 2) =>
  input
    .trim()
    .split(/\s+/)
    .slice(0, maxWords)
    .map((word) => word.charAt(0).toUpperCase())
    .join("");
